import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';

import { IKnmErknmFormExpert } from '../interfaces/IKnmErknmFormExpert';
import { IKnmActExpertSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmActExpertSelectOption';

export const convertExpertsFormValueToKnmData = (experts: IKnmErknmFormExpert[] | undefined): IKnm248['experts'] => {
  if (!experts) {
    return null;
  }

  return experts.map(item => ({
    title: item.title || null,
    type: item.type ? deleteObjectProperties(item.type, ['label', 'value']) : null,
    guid: item.guid || item.listId || null,
    dateCreate: item.dateCreate || null,
  }));
};

export const convertActEventExpertsFormValueToKnmData = (
  experts: IKnmActExpertSelectOption[] | undefined,
): IKnm248['experts'] => {
  if (!experts) {
    return null;
  }

  return experts.map(item => ({
    title: item.value.title || null,
    type: item.value.type ? deleteObjectProperties(item.value.type, ['label', 'value']) : null,
    guid: item.id || item.value.listId || item.value.guid || null,
    dateCreate: item.value.dateCreate || null,
  }));
};
